import React from 'react';
import { IconProps } from '../types';
const MinecraftMace: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="9" y="0" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="10" y="0" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(153, 161, 174, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(191, 206, 231, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(85, 92, 105, 255)" />
<rect x="14" y="1" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(153, 161, 174, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(85, 92, 105, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(153, 161, 174, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(191, 206, 231, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(46, 51, 59, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(153, 161, 174, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(85, 92, 105, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(46, 51, 59, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(124, 132, 145, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(153, 161, 174, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(191, 206, 231, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(153, 161, 174, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(85, 92, 105, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(124, 132, 145, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(153, 161, 174, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(191, 206, 231, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(85, 92, 105, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(102, 108, 122, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(124, 132, 145, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(124, 132, 145, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(124, 132, 145, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(191, 206, 231, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(85, 92, 105, 255)" />
<rect x="15" y="5" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(102, 108, 122, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(124, 132, 145, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(153, 161, 174, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(46, 51, 59, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="15" y="6" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(102, 108, 122, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(46, 51, 59, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="14" y="7" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(80, 99, 144, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(46, 51, 59, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(46, 51, 59, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(80, 99, 144, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(35, 66, 105, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(46, 51, 59, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(80, 99, 144, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(181, 165, 202, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(35, 66, 105, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(80, 99, 144, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(181, 165, 202, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(35, 66, 105, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(80, 99, 144, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(181, 165, 202, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(35, 66, 105, 255)" />
<rect x="0" y="13" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(122, 130, 196, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(35, 66, 105, 255)" />
<rect x="0" y="14" width="1" height="1" fill="rgba(66, 71, 82, 255)" />
<rect x="1" y="14" width="1" height="1" fill="rgba(102, 108, 122, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="0" y="15" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="1" y="15" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
<rect x="2" y="15" width="1" height="1" fill="rgba(30, 34, 41, 255)" />
</svg>);
export default MinecraftMace;